export default __webpack_public_path__ + "images/f8ff02d5a4d60208d1c6256675f28407-comics_small.webp";